/*
 * @TagDialog.vue.vue  SIM卡配置
 * @Description
 * @Author CC
 * @Date 2025/09/20
 */
/* HTML */
<template>
	<el-dialog :title="dialogForm.title" :visible.sync="dialogForm.dialogFormVisible" :close-on-click-modal="false" custom-class="form-dialog forms-box" v-dialogDrag class="dialog_title" @close="handleDialogClose">
		<el-form label-width="110px" class="condition-form-item" ref="configForm" :rules="rules" :model="configForm">
            <el-form-item class="row-items-1" label="ICCID：" prop="iccid">
                <el-input v-model="configForm.iccid" >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="searchSim"></i>
                </el-input>
            </el-form-item>
            <el-form-item class="row-items-1" label="IMSI：" prop="imsi">
                {{configForm.imsi}}
            </el-form-item>
            <el-form-item class="row-items-1" label="SIM套餐：" prop="simPackage">
                {{configForm.simPackage}}
            </el-form-item>
            <el-form-item class="row-items-1" label="SIM状态：" prop="simStatus">
                {{configForm.simStatus}}
            </el-form-item>
            <el-form-item class="row-items-1" label="已用流量：" prop="simUsed">
                {{configForm.simUsed + ' M'}}
            </el-form-item>
            <el-form-item class="row-items-1" label="激活时间：" prop="simActivationTime">
                {{configForm.simActivationTime}}
            </el-form-item>
            <el-form-item class="row-items-1" label="过期时间：" prop="simExpirationTime">
                {{$moment(configForm.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')}}
            </el-form-item>
            <el-form-item class="row-items-1 btn-form-item-r" style="text-align: right;padding-top: 10px;">
<!--                <el-button type="primary" size="mini" @click.native="restoreSim">恢复SIM卡</el-button>-->
                <el-button type="primary" size="mini" @click.native="saveConfig">保存编辑</el-button>
            </el-form-item>
		</el-form>

	</el-dialog>
</template>

<script>
	// SIM信息 组件
	import ApiGpsTag from '../../request/api-gps-tag'

	export default {
		/**
		 * @Des 组件名
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		name: "GpsTagSimConfigDialog",
		/**
		 * @Des 组件引用
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		components: {},
		props: {},
		/**
		 * @Des 数据定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		data() {
			return {
				// 弹出层属性
				dialogForm: {
					title: "",
					dialogFormVisible: false,
					editState: 0
				},
				/**
				 * @Des 标签属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				configForm: {
					// 编号
					did: '',
					// SIM卡信息
					iccid: '',
					imei: '',
                    simPackage:'',
                    simStatus:'',
                    simUsed:'',
                    simActivationTime:'',
                    simExpirationTime:'',
				},
				index: -1,
				/**
				 * @Des 规则属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				rules: {
                    iccid: [
                        { required: true, message: '请输入ICCID', trigger: 'blur' }
                    ]
				}
			}
		},
		created() {},
		mounted() {},
		/**
		 * @Des 方法定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		methods: {
			/**
			 * @Des 打开弹出层
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			openDialog(data, index, state) {
                // 赋值
                this.setData(data, index);
				// console.log(data);
				this.dialogForm.title = '设备【' + this.configForm.did + '】的流量卡配置项';
				if(state) {
					this.dialogForm.editState = state?1:0;
				}
				this.dialogForm.dialogFormVisible = true;
			},


			/**
			 * 设置值
			 * */
			setData(data, index) {
				// console.log(data);
				this.index = index;
				this.configForm = Object.assign({}, this.configForm, data);
            },

			/**
			 * 编辑配置
			 * */
			editConfig() {
				this.dialogForm.editState = 1;
			},
			/**
			 * 取消配置
			 * */
			cancelConfig() {
				this.dialogForm.editState = 0;
				this.cleanValidate('configForm');
			},

			/**
			 * 保存编辑
			 * */
			saveConfig() {
                let params = {
                    did: this.configForm.did,
                    iccid: this.configForm.iccid
                }
                this.$request.postJsonRequest(ApiGpsTag.updateIccidApi, params).then(result => {
                    if(result.code == 0) {
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.$emit("searchGpsTag");
                        this.handleDialogClose();
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.log("保存设备流量卡配置异常：" + this.$request.error.msg);
                })
			},
			/**
			 * 恢复SIM卡
			 * */
            restoreSim() {
                // loading
                this.$confirm(
                    '确认要恢复【'+this.configForm.iccid+'】流量卡信息吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    // loading
                    this.loading = this.$loading({
                        lock: true,
                        text: '正在恢复流量卡信息...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let params = {
                        iccid: this.configForm.iccid
                    }
                    this.$request.postJsonRequest(ApiGpsTag.restoreSimApi, params).then(result => {
                        this.loading.close();
                        if (result.code == 0) {
                            if(result.data && result.data.hasOwnProperty(this.configForm.iccid)){
                                this.$message({
                                    message: '流量卡恢复成功',
                                    type: 'success',
                                    showClose: true,
                                    dangerouslyUseHTMLString: true
                                });
                                this.configForm.imsi = result.data[this.configForm.iccid].imsi;
                                this.configForm.simPackage = result.data[this.configForm.iccid].simPackage;
                                this.configForm.simStatus = result.data[this.configForm.iccid].status;
                                this.configForm.simUsed = result.data[this.configForm.iccid].used;
                                this.configForm.simActivationTime = result.data[this.configForm.iccid].activedate;
                                this.configForm.simExpirationTime = result.data[this.configForm.iccid].expirationTime;
                            }else{
                                this.$message({
                                    message: '流量卡查询无结果',
                                    type: 'error',
                                    showClose: true,
                                    dangerouslyUseHTMLString: true
                                });
                            }
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.log("恢复流量卡配置异常：" + this.$request.error.msg);
                        this.loading.close();
                    })
                });
			},

			/**
			 * @Des 弹窗关闭
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleDialogClose() {
				this.reset();
			},
			/**
			 * @Des 重置
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			reset() {
                this.cleanData();
                this.cleanValidate('configForm');
                this.dialogForm.dialogFormVisible = false;
            },

			/**
			 * @Des 清除表单验证
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			cleanValidate(formName) {
				// 清除表单校验的提示
				if(this.$refs[formName]) {
					// 延时执行
					this.$nextTick(function() {
						this.$refs[formName].clearValidate();
					})
				};
			},
			/**
			 * @Des 清除数据
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			cleanData() {
				// 将数据置为空
				this.configForm = Object.assign({
					// 编号
					did: '',
                    // SIM卡信息
                    iccid: '',
                    imei: '',
                    simPackage:'',
                    simStatus:'',
                    simUsed:'',
                    simActivationTime:'',
                    simExpirationTime:'',
				}, {});
				// 是否编辑
				this.dialogForm.editState = 0;
				this.index = -1;
			},
            searchSim(){
                this.$refs.configForm.validate(valid => {
                    if (!valid) return false;
                    // loading
                    this.loading = this.$loading({
                        lock: true,
                        text: '正在查询流量卡信息...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$request.postJsonRequest(ApiGpsTag.searchSimApi, {
                        iccids: [this.configForm.iccid]
                    }).then(result => {
                        // console.log(result)
                        this.loading.close();
                        if(result.code == 0){
                            if(result.data && result.data.hasOwnProperty(this.configForm.iccid)){
                                this.$message({
                                    message: '流量卡查询成功',
                                    type: 'success',
                                    showClose: true,
                                    dangerouslyUseHTMLString: true
                                });
                                this.configForm.imsi = result.data[this.configForm.iccid].imsi;
                                this.configForm.simPackage = result.data[this.configForm.iccid].simPackage;
                                this.configForm.simStatus = result.data[this.configForm.iccid].status;
                                this.configForm.simUsed = result.data[this.configForm.iccid].used;
                                this.configForm.simActivationTime = result.data[this.configForm.iccid].activedate;
                                this.configForm.simExpirationTime = result.data[this.configForm.iccid].expirationTime;
                            }else{
                                this.$message({
                                    message: '流量卡查询无结果',
                                    type: 'error',
                                    showClose: true,
                                    dangerouslyUseHTMLString: true
                                });
                            }
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        this.$message({
                            message: "流量卡查询异常：" + this.$request.error.msg,
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.loading.close();
                    })
                });
            }
		}
	}
</script>
/* JS */ /* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 800px;
	}

	/deep/ .condition-form-item .el-form-item__label {
		line-height: 30px;
	}

	/deep/ .condition-form-item .el-form-item__content {
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagSimConfigDialog.vue